<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page"><b class="sans_bold">ARK</b></h1>
<p class="center"><span><i>A Novel</i></span></p>
<h1 class="center" style="margin-top:50px;"><b class="sans_bold">CHARLES M<span class="small">C</span>CARRY</b></h1>
<p class="center" style="margin-top:80px;"><span><img alt="MYsteriousPress-blackCMYK.psd" src="MYsteriousPress-blackCM_fmt.png"/></span></p>
<p class="center"><span><b class="sans_normal">A MYSTERIOUSPRESS.COM BOOK</b></span></p>
<p class="center" style="margin-top:20px;"><span><img alt="OpenRoad_Logo_hori.eps" src="BWlogo.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2title_page.vue?f727d228